import { formatCurrency, formatIsoDate } from '@if/core/utils'
import { TableCell, TableRow, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AddFeeSchemaType } from './AddFee-schema'

interface FeeTableRowProps {
  fee: AddFeeSchemaType
}

const getRowBackgroundColor = (amount: number): string | undefined => {
  if (amount > 0) return 'success.main'
  if (amount < 0) return 'error.main'
  return undefined
}

const FeeTableRow = ({ fee }: FeeTableRowProps) => {
  const { t } = useTranslation()

  return (
    <TableRow sx={{ verticalAlign: 'top', backgroundColor: getRowBackgroundColor(fee.amount) }}>
      <TableCell>
        <Typography variant="body2">{t(`enum.EFeeType.${fee.feeType}`)}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{formatIsoDate(fee.effectiveDate)}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{formatCurrency(fee.amount)}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{fee.note ?? ''}</Typography>
      </TableCell>
    </TableRow>
  )
}

export default FeeTableRow
